import React, { useState, useEffect } from 'react';
import { useCursosLazyQuery } from '../graphql/queries/cursos.query';

import {
  CursosPageQuery_apoios,
  CursosPageQuery_assistentes,
  CursosPageQuery_cursos,
  CursosPageQuery_cursos_ofertas,
  CursosPageQuery_cursos_ofertas_turmas,
  CursosPageQuery_horarios,
  CursosPageQuery_unidades,
} from '../graphql/queries/__generated__/CursosPageQuery';

import { useCadastrarCursoMutation } from '../graphql/mutations/cadastrar_curso.mutation';
import { useCadastrarOfertaMutation } from '../graphql/mutations/cadastrar_oferta.mutation';
import { useCadastrarTurmaMutation } from '../graphql/mutations/cadastrar_turma.mutation';
import { useEditarCursoMutation } from '../graphql/mutations/editar_curso.mutation';
import { useEditarOfertaMutation } from '../graphql/mutations/editar_oferta.mutation';
import { useEditarTurmaMutation } from '../graphql/mutations/editar_turma.mutation';
import { useDeletarCursoMutation } from '../graphql/mutations/deletar_curso.mutation';
import { useDeletarOfertaMutation } from '../graphql/mutations/deletar_oferta.mutation';
import { useDeletarTurmaMutation } from '../graphql/mutations/deletar_turma.mutation';
import { InfoOfertasContainer } from '../components/container_info_ofertas/styles';
import { FormCurso, FormularioCurso } from '../components/form_curso';
import { FormOferta, FormularioOferta } from '../components/form_oferta';
import { FormTurma, FormularioTurma } from '../components/form_turma';
import { FormList } from '../../shared/components/form_components/list';
import { Container } from '../../shared/components/layout_components/container/styles';
import { InfoOferta } from '../components/info_oferta';
import { SubContainer } from '../../shared/components/layout_components/sub_container/styles';

const CursoPage: React.FC = () => {
  const [curso, setCurso] = useState<Partial<FormCurso>>();
  const [oferta, setOferta] = useState<Partial<FormOferta>>();
  const [turma, setTurma] = useState<Partial<FormTurma>>();

  const [cursos, setCursos] = useState<CursosPageQuery_cursos[]>([]);
  const [unidades, setUnidades] = useState<CursosPageQuery_unidades[]>([]);
  const [ofertas, setOfertas] = useState<CursosPageQuery_cursos_ofertas[]>();
  const [turmas, setTurmas] = useState<CursosPageQuery_cursos_ofertas_turmas[]>();
  const [horarios, setHorarios] = useState<CursosPageQuery_horarios[]>([]);
  const [apoios, setApoios] = useState<CursosPageQuery_apoios[]>([]);
  const [assistentes, setAssistentes] = useState<CursosPageQuery_assistentes[]>([]);

  const [filter_cursos, setFilterCursos] = useState<CursosPageQuery_cursos[]>([]);
  const [filter_ofertas, setFilterOfertas] = useState<CursosPageQuery_cursos_ofertas[]>();
  const [filter_turmas, setFilterTurmas] = useState<CursosPageQuery_cursos_ofertas_turmas[]>();

  const [obter_cursos, { loading }] = useCursosLazyQuery();
  const [cadastar_curso] = useCadastrarCursoMutation();
  const [cadastar_oferta] = useCadastrarOfertaMutation();
  const [cadastar_turma] = useCadastrarTurmaMutation();

  const [editar_curso] = useEditarCursoMutation();
  const [editar_oferta] = useEditarOfertaMutation();
  const [editar_turma] = useEditarTurmaMutation();

  const [deletar_curso] = useDeletarCursoMutation();
  const [deletar_oferta] = useDeletarOfertaMutation();
  const [deletar_turma] = useDeletarTurmaMutation();

  const on_submit = {
    curso: async (curso: FormCurso) => {
      if (!curso.id_curso) {
        const { data } = await cadastar_curso({
          variables: {
            ...curso,
          },
        });

        if (data) {
          setCursos([...(cursos || []), data.cadastrarCurso as any]);

          alert('Curso cadastrado com sucesso!');
        }
      } else {
        const { data } = await editar_curso({
          variables: {
            ...curso,
            id_curso: curso.id_curso,
          },
        });

        if (data) {
          const index = cursos?.findIndex((c) => curso.id_curso === c.id_curso);

          if (index !== undefined && index !== -1) {
            const novos_cursos = [
              ...(cursos?.slice(0, index) || []),
              data.editarCurso,
              ...(cursos?.slice(index + 1) || []),
            ];

            setCursos(novos_cursos as any);
            setFilterCursos(novos_cursos as any);
          }

          alert('Curso editado com sucesso!');
        }
      }

      on_cancel_edit.curso();
    },
    oferta: async (oferta: FormOferta) => {
      if (!oferta.id_oferta) {
        const { data } = await cadastar_oferta({
          variables: {
            ...oferta,
          },
        });

        if (data) {
          setOfertas([...(ofertas || []), data.cadastrarOferta]);

          alert('Oferta cadastrada com sucesso!');
        }
      } else {
        const { data } = await editar_oferta({
          variables: {
            ...oferta,
            id_oferta: oferta.id_oferta,
          },
        });

        if (data) {
          const index = ofertas?.findIndex((o) => oferta.id_oferta === o.id_oferta);

          if (index !== undefined && index !== -1) {
            setOfertas([
              ...(ofertas?.slice(0, index) || []),
              data.editarOferta,
              ...(ofertas?.slice(index + 1) || []),
            ]);
          }

          alert('Oferta editada com sucesso!');
        }
      }

      on_cancel_edit.oferta();
    },
    turma: async (turma: FormTurma) => {
      if (!turma.id_turma) {
        const { data } = await cadastar_turma({
          variables: {
            ...turma,
          },
        });

        if (data) {
          setTurmas([...(turmas || []), data.cadastrarTurma]);

          alert('Turma cadastrada com sucesso!');
        }
      } else {
        const { data } = await editar_turma({
          variables: {
            ...turma,
            id_turma: turma.id_turma,
          },
        });

        if (data) {
          const index = turmas?.findIndex((t) => turma.id_turma === t.id_turma);

          if (index !== undefined && index !== -1) {
            setTurmas([
              ...(turmas?.slice(0, index) || []),
              data.editarTurma,
              ...(turmas?.slice(index + 1) || []),
            ]);
          }
        }

        alert('Turma editada com sucesso!');
      }

      on_cancel_edit.turma();
    },
  };

  const on_edit = {
    curso: (curso: CursosPageQuery_cursos) => {
      setCurso({
        id_curso: curso.id_curso,
        id_unidade: curso.id_unidade || undefined,
        dsc_nome_curso: curso.dsc_nome_curso || undefined,
        dsc_sigla_curso: curso.dsc_sigla_curso || undefined,
        id_apoio: curso.id_apoio,
        ativo: curso.ativo,
      });

      setOferta({ id_curso: curso.id_curso });
      setOfertas(curso.ofertas);
    },
    oferta: (oferta: CursosPageQuery_cursos_ofertas) => {
      setOferta({
        id_oferta: oferta.id_oferta,
        id_curso: curso?.id_curso,
        num_oferta: oferta.num_oferta || undefined,
        num_ano: oferta.num_ano || undefined,
        num_semestre: oferta.num_semestre || undefined,
        id_assistente: oferta.id_assistente,
        ativa: oferta.ativa,
      });

      setTurmas(oferta.turmas);
      setTurma({ id_oferta: oferta.id_oferta });
    },
    turma: (turma: CursosPageQuery_cursos_ofertas_turmas) => {
      setTurma({
        id_turma: turma.id_turma,
        id_oferta: oferta?.id_oferta,
        num_turma: turma.num_turma,
        dias_semana: turma.dias_semana || undefined,
        id_horario: turma.id_horario,
        ativa: turma.ativa,
      });
    },
  };

  const on_cancel_edit = {
    curso: () => {
      setCurso(undefined);
      setOferta(undefined);
      setOfertas(undefined);
      setTurma(undefined);
      setTurmas(undefined);
    },
    oferta: () => {
      setOferta({ id_curso: curso?.id_curso });
      setTurma(undefined);
      setTurmas(undefined);
    },
    turma: () => {
      setTurma({ id_oferta: oferta?.id_oferta });
    },
  };

  const on_delete = {
    curso: async (id_curso: number) => {
      await deletar_curso({ variables: { id_curso } });
      setCursos((cursos) => cursos.filter((c) => c.id_curso !== id_curso));
      setFilterCursos((cursos) => cursos.filter((c) => c.id_curso !== id_curso));
      on_cancel_edit.curso();
    },
    oferta: async (id_oferta: number) => {
      await deletar_oferta({ variables: { id_oferta } });
      setOfertas((ofertas) => ofertas?.filter((o) => o.id_oferta !== id_oferta));
      on_cancel_edit.oferta();
    },
    turma: async (id_turma: number) => {
      await deletar_turma({ variables: { id_turma } });
      setTurmas((turmas) => turmas?.filter((t) => t.id_turma !== id_turma));
      on_cancel_edit.turma();
    },
  };

  const on_search = {
    cursos: async (search: string) => {
      setFilterCursos(
        cursos?.filter((c) => c.dsc_nome_curso?.toLowerCase().includes(search.toLowerCase())) || []
      );
    },
    ofertas: (search: string) => {
      setFilterOfertas(ofertas?.filter((o) => o.num_oferta?.toString().includes(search)) || []);
    },
    turmas: (search: string) => {
      setFilterTurmas(turmas?.filter((t) => t.num_turma?.toString().includes(search)) || []);
    },
  };

  const render_middle_components = (ofertas: CursosPageQuery_cursos_ofertas[]) => {
    if (ofertas?.length && !curso) {
      return (
        <InfoOfertasContainer>
          {ofertas.map((oferta) => (
            <InfoOferta key={oferta.id_oferta} oferta={oferta} loading={loading} />
          ))}
        </InfoOfertasContainer>
      );
    }
  };

  const obter_dados_iniciais = async () => {
    const { data } = await obter_cursos({
      variables: {
        descricao: '',
      },
    });

    if (data) {
      setCursos(data.cursos);
      setFilterCursos(data.cursos);
      setUnidades(data.unidades);
      setHorarios(data.horarios);
      setApoios(data.apoios);
      setAssistentes(data.assistentes);
    }
  };

  useEffect(() => {
    if (ofertas) setFilterOfertas(ofertas);
    if (turmas) setFilterTurmas(turmas);
  }, [ofertas, turmas]);

  useEffect(() => {
    document.title = 'SisIEC - Cursos';
    obter_dados_iniciais();
  }, []);

  return (
    <Container>
      <SubContainer flex={4}>
        <FormularioCurso
          onSubmit={on_submit.curso}
          onCancel={on_cancel_edit.curso}
          curso={curso}
          unidades={unidades}
          apoios={apoios}
        />
        <FormList
          list_name='Cursos'
          items={filter_cursos?.map((c) => ({
            data: c,
            id: c.id_curso,
            label: c.dsc_nome_curso || '',
            middle_component: render_middle_components(c.ofertas),
          }))}
          onSearch={on_search.cursos}
          onEdit={on_edit.curso}
          onDelete={on_delete.curso}
          loading={loading}
        />
      </SubContainer>

      {ofertas && curso && (
        <SubContainer flex={3}>
          <FormularioOferta
            onSubmit={on_submit.oferta}
            onCancel={on_cancel_edit.oferta}
            oferta={oferta}
            assistentes={assistentes}
          />
          <FormList
            list_name='Ofertas'
            items={filter_ofertas?.map((o) => ({
              data: o,
              id: o.id_oferta,
              label: String(o.num_oferta) || '',
            }))}
            onSearch={on_search.ofertas}
            onEdit={on_edit.oferta}
            onDelete={on_delete.oferta}
            loading={loading}
          />
        </SubContainer>
      )}

      {turmas && oferta && (
        <SubContainer flex={3}>
          <FormularioTurma
            onSubmit={on_submit.turma}
            onCancel={on_cancel_edit.turma}
            turma={turma}
            horarios={horarios}
          />
          <FormList
            list_name='Turmas'
            items={filter_turmas?.map((t) => ({
              data: t,
              id: t.id_turma,
              label: String(t.num_turma),
            }))}
            onSearch={on_search.turmas}
            onEdit={on_edit.turma}
            onDelete={on_delete.turma}
            loading={loading}
          />
        </SubContainer>
      )}
    </Container>
  );
};

export { CursoPage };
// recompilation trigger
